import script from "./ViewLeavesCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewLeavesCalendar.vue?vue&type=script&setup=true&lang=js"

import "./ViewLeavesCalendar.vue?vue&type=style&index=0&id=337936dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-337936dd"]])

export default __exports__